// @flow
import React from "react"
import { compose, type HOC, withHandlers } from "recompose"
import { formatTelNumber } from "data/affiliate/formatters"
import { Text } from "componentsStyled/Typography/Texts"
import RegularOpeningHoursTable from "../../../Affiliate/Content/Info/OpeningHoursTable/Regular"
import { StyledInput } from "componentsStyled/Forms/Input"
import type { GooglePlace } from "data/locations/types"
import {
  AffiliateLink,
  SectionTitle,
  LinkWrap,
} from "../../../Affiliate/Content/styled"
import {
  ContactDetailsWrap
} from "./styled"

const PlaceDetails = ({ handleEmail, affiliate, setAffiliateEmail }) => {
  return (
    <React.Fragment>
      <Text strong bigOnAllDisplays uppercase black>
        {" "}
        {affiliate.affiliateName}{" "}
      </Text>
      <SectionTitle>Address</SectionTitle>
      <LinkWrap>
        <AffiliateLink to={affiliate.url}>
          {affiliate.formattedAddress}
        </AffiliateLink>
      </LinkWrap>
      {affiliate.formattedOpeningHours && (
        <div>
          <Text> Store Hours </Text>
          <RegularOpeningHoursTable
            data={affiliate.formattedOpeningHours}
          />
        </div>
      )}
      {affiliate.formattedPhoneNumber && affiliate.website && (
        <ContactDetailsWrap>
          <SectionTitle>Contacts</SectionTitle>
          {affiliate.formattedPhoneNumber && (
            <Text lh={3}>
              <Text inline>Tel:</Text> &nbsp;
              <AffiliateLink
                to={`tel:${formatTelNumber(affiliate.formattedPhoneNumber)}`}
              >
                {affiliate.formattedPhoneNumber}
              </AffiliateLink>
            </Text>
          )}
          {affiliate.website && (
            <Text lh={3}>
              <Text inline>Website:</Text> &nbsp;
              <AffiliateLink to={affiliate.website}>
                {affiliate.website}
              </AffiliateLink>
            </Text>
          )}
            <Text lh={3}>
              <SectionTitle inline>Store Email:</SectionTitle> &nbsp;
              <StyledInput required type="text" value={affiliate.affiliateEmail} name="email" label="email" onChange={handleEmail} />
            </Text>
        </ContactDetailsWrap>
      )}
    </React.Fragment>
  )
}

type Outter = {
  affiliate: GooglePlace,
  setAffiliateEmail: (affiliateEmail: string) => void,
}

const enhancer: HOC<*, Outter> = compose(
  withHandlers(
    {
      handleEmail: props => (event) => {
        props.setAffiliateEmail(event.target.value)
      },
    },
  ),
)

export default enhancer(PlaceDetails)



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/AffiliateSelector/PlaceDetails/index.js